import { useState, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

export const useBulkActions = (products, onSuccess) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectAll = useCallback(() => {
    setSelectedIds(products.map(p => p.id));
  }, [products]);

  const deselectAll = useCallback(() => {
    setSelectedIds([]);
  }, []);

  const toggleSelect = useCallback((productId) => {
    setSelectedIds(prev =>
      prev.includes(productId)
        ? prev.filter(id => id !== productId)
        : [...prev, productId]
    );
  }, []);

  const executeBulkAction = useCallback(async (action) => {
    if (!selectedIds.length) {
      toast.error('אנא בחר לפחות מוצר אחד');
      return;
    }

    try {
      setLoading(true);

      switch (action) {
        case 'activate':
          await axios.patch('/api/products/bulk', {
            ids: selectedIds,
            status: 'active'
          });
          toast.success(`${selectedIds.length} מוצרים הופעלו בהצלחה`);
          break;

        case 'deactivate':
          await axios.patch('/api/products/bulk', {
            ids: selectedIds,
            status: 'inactive'
          });
          toast.success(`${selectedIds.length} מוצרים הושבתו בהצלחה`);
          break;

        case 'delete':
          const confirmed = window.confirm(
            `האם אתה בטוח שברצונך למחוק ${selectedIds.length} מוצרים?`
          );
          if (!confirmed) return;

          await axios.delete('/api/products/bulk', {
            data: { ids: selectedIds }
          });
          toast.success(`${selectedIds.length} מוצרים נמחקו בהצלחה`);
          break;

        default:
          console.warn('Unknown bulk action:', action);
          return;
      }

      // Reset selection and call success callback
      deselectAll();
      if (onSuccess) onSuccess();

    } catch (error) {
      toast.error(error.response?.data?.message || 'שגיאה בביצוע הפעולה');
    } finally {
      setLoading(false);
    }
  }, [selectedIds, deselectAll, onSuccess]);

  // Get selected products objects
  const selectedItems = products.filter(p => selectedIds.includes(p.id));

  return {
    selectedIds,
    selectedItems, // Array of selected product objects
    selectAll,
    deselectAll,
    toggleSelect,
    executeBulkAction,
    loading,
    selectedCount: selectedIds.length
  };
};

